var _circle, _circle2, _g, _g2, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2345_446",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#ECEDEE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2345_446)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2345_446)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 14,
    width: 112,
    height: 92,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 30,
    width: 64,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 38,
    width: 42.6667,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 54,
    width: 64,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 62,
    width: 64,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 70,
    width: 64,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 78,
    width: 64,
    height: 4,
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 86,
    width: 32,
    height: 4,
    fill: "#ECEDEE"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2345_446)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 64,
    height: 92,
    fill: "#E0F5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9993 68.7613C28.2167 68.7613 18.666 75.3226 18.666 82.476V84C18.666 85.4733 19.8593 86.6666 21.3327 86.6666H58.666C60.1393 86.6666 61.3327 85.4733 61.3327 84V82.476C61.3327 75.3226 51.782 68.7613 39.9993 68.7613Z",
    fill: "#008B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6663 70.6666C46.6663 73.196 43.9997 76 39.9997 76C35.9997 76 33.333 73.196 33.333 70.6666C33.333 67.1506 33.333 61.2866 33.333 61.2866H46.6663C46.6663 61.2866 46.6663 67.1506 46.6663 70.6666Z",
    fill: "#5B4530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8882 52H51.1855V57.3333H52.1229C52.8095 57.3333 53.3949 56.9173 53.5109 56.3467L53.9696 54.076C54.1896 52.9907 53.1962 52 51.8882 52Z",
    fill: "#68523E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.112 52H28.8146V57.3333H27.8773C27.1906 57.3333 26.6053 56.9173 26.4893 56.3467L26.0306 54.076C25.8106 52.9907 26.804 52 28.112 52Z",
    fill: "#68523E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 36.5333C34.0787 36.5333 28 37.4333 28 50.2333C28 51.2573 28 58.0693 28 59.164C28 63.7333 35.2 69.3333 40 69.3333C44.8 69.3333 52 63.7333 52 59.164C52 58.0693 52 51.2587 52 50.2333C52 37.4333 45.9213 36.5333 40 36.5333Z",
    fill: "#68523E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9993 35.3933C34.194 35.3933 33.3327 37.5746 33.3327 37.5746C30.9727 37.9226 26.666 41.38 26.666 45.332C26.666 47.5373 27.0193 49.1666 27.9993 54.6653C28.726 45.9386 30.998 42.6653 33.3327 42.6653C35.022 42.6653 36.3633 43.9986 39.9993 43.9986C43.07 43.9986 43.8327 42.6653 46.666 42.6653C50.666 42.6653 51.9993 53.2893 51.9993 54.6653C52.8007 50.652 53.3327 47.2586 53.3327 45.332C53.3327 40.76 48.278 35.3933 39.9993 35.3933Z",
    fill: "#1A1B1F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 14,
    width: 11,
    height: 92,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2345_446",
    x: 65,
    y: 9,
    width: 126,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2345_446"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2345_446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2345_446",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2345_446",
    x: 1,
    y: 9,
    width: 78,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2345_446"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2345_446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2345_446",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.3c99308a2b7f9737de914aafb3e3f3de.svg";
export { ForwardRef as ReactComponent };